module.exports = __webpack_public_path__ + "img/oner.db64548e.png";